import LoadingControls from './loading-controls.component';

interface LoadingPreviewProps {
  message: string;
}

const LoadingPreview = ({ message }: LoadingPreviewProps) => {
  return (
    <div data-cy="loading-preview" className="text-foreground mt-4">
      <LoadingControls className="mb-2" />
      <div data-cy="loading-preview-message">{message}</div>
    </div>
  );
};

export default LoadingPreview;
